import { Space, Table } from "antd";
import { useTranslation } from "react-i18next";

import type { ColumnsType } from "antd/es/table";
import { EditOutlined } from "@ant-design/icons";

import { memo } from "react";
import { IHealthClient } from "@interfaces";
import styled from "styled-components";
import { SharedIconButton } from "@components";
const btnSty = { background: "#00AA67" };

interface IProps {
  data: IHealthClient[];
  callback: () => void;
}
export const HealthClientTable = memo(({ data, callback }: IProps) => {
  const { t } = useTranslation();
  const dataSource: IHealthClient[] = data;

  const columns: ColumnsType<IHealthClient> = [
    {
      title: t("page.client_name"),
      dataIndex: "client_name",
      key: "1",
    },
    {
      title: t("page.client_phoneNumber"),
      dataIndex: "client_phoneNumber",
      key: "2",
    },
    {
      title: t("page.client_age"),
      dataIndex: "client_age",
      key: "3",
    },
    {
      title: t("page.client_region"),
      dataIndex: "client_region_name",
      key: "4",
    },
    {
      title: t("page.client_township"),
      dataIndex: "client_township_name",
      key: "5",
    },
    {
      title: t("page.client_gender"),
      dataIndex: "client_gender",
      key: "6",
    },
    {
      title: t("page.actions"),
      key: "page_action",
      render: (_, record) => (
        <Space size="middle">
          <StyledSpace onClick={callback}>
            <SharedIconButton
              style={btnSty}
              type="primary"
              icon={<EditOutlined />}
              size={"small"}
            />
            <span className="label">{t("page.edit")}</span>
          </StyledSpace>
        </Space>
      ),
    },
  ];

  return <Table dataSource={dataSource} rowKey={"userId"} columns={columns} pagination={false} />;
});
const StyledSpace = styled(Space)`
  cursor: pointer;
  .label{
    color: #00AA67;
  }
`;
